<template>
  <v-bottom-navigation
    :value="value"
    color="primary"
    horizontal
    class="attendance-bottom"
    style="position: fixed;"
  >
    <v-btn
    to="/attendance"
    >
      <span>{{ $t('attendance.value') }}</span>

      <v-icon>mdi-heart</v-icon>
    </v-btn>
    <v-btn
    to="/total"
    >
      <span>{{$t('summary')}}</span>

      <v-icon>mdi-heart</v-icon>
    </v-btn>

    <v-btn
    to="/examineCard"
    >
      <span>{{ $t('attendance.cardReplacement') }}</span>

      <v-icon>mdi-map-marker</v-icon>
    </v-btn>
    <v-btn
      to="/calibration"
    >
      <span>{{ $t('attendance.check') }}</span>

      <v-icon>mdi-map-marker</v-icon>
    </v-btn>
    <v-btn
      to="/worktimerule"
    >
      <span>{{ $t('user') }} {{ $t('strategy') }}</span>

      <v-icon>mdi-map-marker</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
  export default {
    name: 'AttendanceFooter',
    data: () => ({ value: 1 }),
  }
</script>
<style>
.attendance-bottom {
  height: 20px;
  text-align:center;
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layouts/components/AttendanceFooter.vue